import CheckIcon from 'assets/icons/check-icon.svg?component'
import Udv from 'assets/icons/udv-frame.svg?component'
import { Modal } from 'components/UI/Modal'
import Typography from 'components/UI/Typography'
import { useState } from 'react'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import Iframe from 'react-iframe'
import tw from 'twin.macro'

const PassportBlock = ({ url }: { url: string }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const onClose = () => {
    setOpen(false)
  }

  const openModal = () => {
    setOpen(true)
  }

  return (
    <div tw='p-5 bg-secondary space-y-4 sm:rounded-2xl'>
      <Typography variant='body' weight='bold'>
        {t('flow-digital-doc')}
      </Typography>
      <Typography variant='subbody' text twStyle={tw`text-grey-dark`}>
        {t('flow-confirm-sms')}
      </Typography>
      <Fragment>
        <div tw='flex items-center space-x-2'>
          <CheckIcon tw='flex-shrink-0' />
          <Typography weight='bold' twStyle={tw`text-s14`}>
            {t('flow-digital-doc-accepted')}
          </Typography>
        </div>
        <div tw='flex items-center space-x-4'>
          <Udv tw='cursor-pointer hover:scale-100' onClick={openModal} />
        </div>
      </Fragment>

      <Modal
        title={''}
        open={open}
        onClose={onClose}
        wrapperStyle={tw`overflow-hidden`}
        twStyle={tw`min-w-[788px] p-5`}
      >
        <Iframe width='100%' tw='min-h-[80vh] py-5' url={url} />
      </Modal>
    </div>
  )
}
export default PassportBlock
